import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {}
export type Action = {}

export const UlinkTemplate: Template<State, Action> = () => {
  return null
}
